import tw from "twin.macro"

const Headline = tw.div`text-4xl md:text-5xl xl:text-6xl font-bold leading-none`

export default Headline